import { Typography, Counter, Button } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import { Check } from '@ui/components/icons';
import { Link } from 'react-router-dom';
import { FC } from 'react';

export const OnboardingFinish: FC = () => {
  const { user } = useCurrentUser();
  const { t } = useTranslation();

  return (
    <section className="space-y-6">
      <Typography variant="h400" element="h1">
        {t('ONBOARDING.FINISH.TITLE')}
      </Typography>

      <Typography variant="paragraphLargeBook">{t('ONBOARDING.FINISH.DESCRIPTION_1')}</Typography>

      <Typography variant="paragraphLargeBook">{t('ONBOARDING.FINISH.DESCRIPTION_2')}</Typography>

      <div className="flex justify-center border-b border-border-default pb-6">
        <Counter variant="success" size="huge">
          <Check className="size-10" />
        </Counter>
      </div>

      <Button variant="primary" size="large" asChild wide>
        <Link to={`/${user?.companies[0]?.id}`} replace>
          {t('ONBOARDING.FINISH.GO_TO_DASHBOARD')}
        </Link>
      </Button>
    </section>
  );
};
